export const enWidgetTranslations = {
    WIDGET__SOURCE_NAME__REVIEWS_GENERATOR: 'From customer messages',
    WIDGET__BREADCRUMBS_TITLE: 'Widget list',
    WIDGET__LIST_TITLE: 'List of created review widgets',
    WIDGET__CREATE_BUTTON: 'Create widget',
    WIDGET__LIST_EMPTY_TITLE: 'No widgets created',
    WIDGET__LIST_EMPTY_SUBTITLE: 'Display reviews from all platforms in one widget on your site',
    WIDGET__LIST_SUBTITLE: 'Build customer trust on your website. Set up a widget and display reviews on your site.',
    WIDGET__CARD_TYPE_EMBEDDED: 'Embedded widget',
    WIDGET__CARD_TYPE_STRING: 'Inline widget',

    WIDGET__CREATE_TITLE: 'Widget creation',
    WIDGET__EDIT_TITLE: 'Edit widget',
    WIDGET__CREATE_SETTINGS: 'Main settings',
    WIDGET__FORM__REQUIRED_FIELDS_TOOLTIP: 'Fill in the required fields',
    WIDGET__CREATE_THEME: 'Theme',
    WIDGET__CREATE_THEME__LIGHT: 'Light',
    WIDGET__CREATE_THEME__DARK: 'Dark',
    WIDGET__CREATE_NAME: 'Name',
    WIDGET__CREATE_NAME__PLACEHOLDER: 'Widget name in dashboard',
    WIDGET__CREATE_TAGS: 'Tags',
    WIDGET__CREATE_TAGS__PLACEHOLDER: 'Select tags',
    WIDGET__CREATE_AUTO_TAGS: 'Autotags',
    WIDGET__CREATE_AUTO_TAGS__PLACEHOLDER: 'Select autotags',
    WIDGET__CREATE_CUSTOM_CSS: 'Custom CSS',
    WIDGET__CREATE_CUSTOM_CSS__PLACEHOLDER: 'Enter your custom CSS styles',
    WIDGET__CREATE_CUSTOM_CSS__ERROR_SIZE: 'CSS cannot exceed {maxSize} KB',
    WIDGET__CREATE_DOMEN: 'Domain',
    WIDGET__CREATE_DOMEN__PLACEHOLDER: 'locator.domain.com',
    WIDGET__CREATE_MAX_REVIEWS: 'Number of reviews to display (max. 100)',
    WIDGET__CREATE_SOURCES: 'Review sources',
    WIDGET__CREATE_SOURCES__PLACEHOLDER: 'Select review sources',
    WIDGET__CREATE_RATING_TO_SHOW: 'Number of stars in review',
    WIDGET__CREATE_MINIMAL_RATING: 'Minimal rating',
    WIDGET__CREATE_LANGUAGE: 'Language',
    WIDGET__CREATE_EMBEDDED_TITLE: 'Widget title',
    WIDGET__CREATE_AUTO_NEXT_REVIEW: 'Automatic review switching',
    WIDGET__CREATE_REVIEW_SHOW_TIME: 'Display time for one review, sec.',
    WIDGET__CREATE_COLORS: 'Colors',
    WIDGET__CREATE_RATING_STAR_COLOR: 'Rating stars color',
    WIDGET__CREATE_BUTTON_COLOR: 'Button color',
    WIDGET__CREATE_BACKGROUND_COLOR: 'Widget background color',
    WIDGET__CREATE_REVIEWS_ELEMENTS: 'Review elements',
    WIDGET__CREATE_SHOW_LINK: 'Display link to review in catalog',
    WIDGET__CREATE_SHOW_REVIEW_COUNT: 'Show total review count',
    WIDGET__CREATE_ADDRESS_AND_AVG_RATING: 'Location address (if available) and its average rating',
    WIDGET__CREATE_PREVIEW_TITLE: 'Preview',
    WIDGET__CREATE_PREVIEW_HELP: 'The widget displays up to 20 latest reviews per platform. Reviews are updated daily.',
    WIDGET__CREATE_PREVIEWS_BUTTON: 'Open full preview',
    WIDGET__PREVIEW__SELECTION_EXPIRED__TITLE: 'Company selection has expired',
    WIDGET__PREVIEW__SELECTION_EXPIRED__DESCRIPTION:
        'Select the companies again or reload the page to bring the preview back.',
    WIDGET__CREATE_CONNECTION: 'Connection',
    WIDGET__CREATE: 'Widget',
    WIDGET__CONNECT_TITLE: 'Review widget is configured! Now you can connect it.',
    WIDGET__CONNECT_BUTTON_EMAIL: 'Send instructions by email',
    WIDGET__CONNECT_TO_SITE_TITLE: 'Embed JS widget on your site',
    WIDGET__CONNECT_TO_SITE_DESCRIPTION:
        'The widget can be placed inside pages of an existing website. To connect, insert the code below into your site code. The site must be on the domain specified in the widget settings.',
    WIDGET__DELETE__CONFIRM__TITLE: 'Deleting review widget',
    WIDGET__DELETE__CONFIRM__DESCRIPTION: 'Widget {widgetName} will be deleted. Confirm?',
    WIDGET__DELETE__SUCCESS__TITLE: 'Widget deleted',
    WIDGET__DELETE__SUCCESS__DESCRIPTION: 'Widget {widgetName} deleted',
    WIDGET__DELETE__ERROR: 'Error deleting widget',
    WIDGET_SETTINGS_PAGE__WIDGET_CODE_MODAL__TITLE: 'Widget installation on site',
    WIDGET_SETTINGS_PAGE__WIDGET_CODE_MODAL__DESCRIPTION__NAME: 'Name: «{name}»',
    WIDGET_SETTINGS_PAGE__WIDGET_CODE_MODAL__DESCRIPTION__INSTRUCTIONS__TITLE:
        'Copy the widget code and paste it on your site.',
    WIDGET_SETTINGS_PAGE__WIDGET_CODE_MODAL__DESCRIPTION__INSTRUCTIONS__DESCRIPTION:
        'All settings saved in your personal account will be updated on the site automatically.',
    WIDGET_SETTINGS_PAGE__WIDGET_CODE_MODAL__DESCRIPTION__INSTRUCTIONS__COPY_BUTTON: 'Copy',
    WIDGET_SETTINGS_PAGE__WIDGET_CODE_MODAL__DESCRIPTION__INSTRUCTIONS__COPY_BUTTON__SUCCESS: 'Copied',
    WIDGET__CARD__PAGES__SINGULAR: 'page',
    WIDGET__CARD__PAGES__FEW: 'pages',
    WIDGET__CARD__PAGES__MANY: 'pages',
    WIDGET__CARD__RESOURCES_MODAL__TITLE: 'Pages with widget',
    WIDGET__CARD__RESOURCES_MODAL__DESCRIPTION: 'Below are the pages where the widget was installed.',
    WIDGET__CARD__CATALOGS_TOOLTIP__TITLE: 'Sources: {count}',
    WIDGET__CARD__CATALOGS_TOOLTIP__MORE: '{count} more sources…',
    WIDGET__CARD__STATS__CREATED: 'Created:',
    WIDGET__CARD__STATS__INSTALLED: 'Installed:',
    WIDGET__CREATE__SUCCESS__TITLE: 'Widget created',
    WIDGET__CREATE__SUCCESS__DESCRIPTION: 'Widget {widgetName} created successfully',
    WIDGET__CREATE__UPDATE_ERROR: 'Widget created, but failed to apply settings',
    WIDGET__UPDATE__SUCCESS__TITLE: 'Widget updated',
    WIDGET__UPDATE__SUCCESS__DESCRIPTION: 'Widget {widgetName} updated successfully',
    WIDGET__CONNECT__EMAIL__TITLE: 'Send instructions by email',
    WIDGET__CONNECT__EMAIL__HELP:
        'You can send information for connecting the feedback widget by email to your Web developer.',
    WIDGET__CONNECT__EMAIL__EMAIL_INPUT__LABEL: 'Email',
    WIDGET__CONNECT__EMAIL__SUCCESS__TITLE: 'Email sent',
    WIDGET__CONNECT__EMAIL__SUCCESS__DETAILS: 'Connection information has been sent.',
};
